// extracted by mini-css-extract-plugin
export default {"closedRegistrationMessageContainer":"qwG9Oi","closedRegistrationMessage":"LkY8Dc","mobileFontSize":"dej_K9"};